import React from "react";
import { Row, Col } from "reactstrap";
import { SiteInformationProps } from "./type";
import "./index.scss";
import { Button } from "shared";
import { useHistory } from "react-router-dom";
import FollowerManager from "components/FollowerManager";
import AssignmentManager from "components/AssignmentManager";
import t from "utils/Lang";

const SiteInformation = ({
  address,
  createdAt,
  creator,
  siteName,
  assignees,
  followers,
  image,
  currentStatus,
  formatSite,
  typeSite,
  dataStore,
  siteId,
  users,
}: SiteInformationProps) => {
  const history = useHistory();
  return (
    <Row className="site-information-container">
      <Col md={12} lg={8}>
        <div style={{ display: "flex", marginBottom: 15 }}>
          <img
            className="site-information__avatar"
            src={
              image ||
              "https://file.hstatic.net/1000075078/file/store_xuanla_hn_master.jpg"
            }
          />
          <div className="site-information__info">
            <span className="site-information__info__name">
              {siteName}
              <span className="site-information__info__status">
                {currentStatus}
              </span>
            </span>
            <span style={{ marginTop: 4 }}>
              {t().site_listing__address}:{" "}
              <span className="site-information__info__value">{address}</span>
            </span>
            <span style={{ marginTop: 4 }}>
              {t().site_listing__created_by}:{" "}
              <span className="site-information__info__value">{creator}</span> |{" "}
              {t().site_listing__created_on}:{" "}
              <span className="site-information__info__value">{createdAt}</span>
            </span>
            <div
              style={{ marginTop: 12, display: "flex", alignItems: "center" }}
            >
              {!!formatSite && (
                <span className="site-information__info__site-tag">
                  {formatSite}
                </span>
              )}
              {!!typeSite && (
                <span
                  className="site-information__info__site-tag"
                  style={{ marginLeft: 8 }}
                >
                  {typeSite}
                </span>
              )}
              <Button
                label={t().contract}
                type="primary"
                size="small"
                style={{ marginLeft: 8 }}
                onClick={() => history.push(`/contract/${siteId}`)}
              />
              {dataStore && (
                <Button
                  label={t().home__store_listing}
                  type="primary"
                  size="small"
                  style={{ marginLeft: 8 }}
                  onClick={() => history.push(`/store/${dataStore.id}`)}
                />
              )}
            </div>
          </div>
        </div>
      </Col>
      <Col md={12} lg={4} className="site-information__additional-info">
        <AssignmentManager
          assignees={assignees}
          contentType="site"
          contentId={siteId}
          users={users}
        />
        <br />
        <FollowerManager
          followers={followers}
          contentType="site"
          contentId={siteId}
          users={users}
        />
      </Col>
    </Row>
  );
};

export default SiteInformation;
